const errorMapping = {
    purchaseRetryFailure: 'We couldn’t complete your subscription.',
    planFeaturesAreAlreadyProvided: 'Great news! You already have an active subscription and do not need to buy another one. Simply click OK to proceed to the login page.',
    planIsDisabled: 'This plan is no longer available.',
    purchaseIsBanned: 'Purchases are currently unavailable on this account due to that previous payments resulted in a payment dispute. To ensure the security of our company, we are unable to accept further orders from accounts with this history. Click OK to close this message.',
    wrongTenant: 'It looks like this email is already being used on our sister site, prelander.boundly.com.\n\nTap OK to continue to prelander.boundly.com. Tap Cancel to stay on this page.'
};

const errorMapper = {
    toDomain(error) {
        return {
            ...error,
            message: errorMapping[error.code]
        };
    }
};

export {
    errorMapper
};
